export default __webpack_public_path__ + "static/media/cheapest_carrier_rule.2eeb2956.svg";